import { ConfirmationModal } from '@oy/uidesktop';
import { Product } from 'src/constants';
import { useTranslate, useUpgradeAccountPage } from 'src/hooks';

type UpgradeAccountModalProps = {
  showModal: boolean;
  onClose: () => void;
  product: Product;
};

const UpgradeAccountModal = ({
  showModal,
  onClose,
  product,
}: UpgradeAccountModalProps) => {
  const { getTranslation } = useTranslate();
  const { openUpgradeAccountPage } = useUpgradeAccountPage();
  return (
    <ConfirmationModal
      show={showModal}
      title={getTranslation('home_verifyBusiness_modal_title')}
      description={
        product === Product.Disbursement
          ? getTranslation('home_verifyBusiness_withdrawalModal_description')
          : getTranslation('home_verifyBusiness_topupModal_description')
      }
      primaryButtonName={getTranslation('home_verifyBusinessNow')}
      secondaryButtonName={getTranslation('common_later')}
      onPrimaryButtonClick={() => {
        onClose();
        openUpgradeAccountPage();
      }}
      onSecondaryButtonClick={onClose}
    ></ConfirmationModal>
  );
};

export default UpgradeAccountModal;
